import { cn } from "../../../helpers";
import styles from "./Alert.module.scss";

interface AlertProps {
    type?: "info" | "success" | "warning" | "danger";
    children: React.ReactNode;
    icon?: React.ReactNode;
    className?: string;
    contentClassName?: string;
}

export default function Alert({
    children,
    icon,
    className,
    type,
    contentClassName,
}: AlertProps) {
    const defaultIcon = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-info"
        >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
    );

    if (defaultIcon || icon) {
        return (
            <div
                className={cn(styles.alert, className, {
                    [styles.info]: type === "info" || !type,
                    [styles.success]: type === "success",
                    [styles.warning]: type === "warning",
                    [styles.danger]: type === "danger",
                })}
                role={type === "danger" || type === "warning" ? "alert" : "status"}
            >
                <span className={styles.icon}>{defaultIcon}</span>
                <div className={cn(contentClassName)}>{children}</div>
            </div>
        );
    }

    return <div className={cn(styles.alert, className)}>{children}</div>;
}
